export const BOX_SIZE = 10;

export interface WorldCoord {
  x: number;
  y: number;
}

export interface BoxCoord {
  boxX: number;
  boxY: number;
}

export interface CellBoxPosition {
  boxX: number;
  boxY: number;
  cellX: number;
  cellY: number;
}

/**
 * Converts integer world coordinates (x, y) to box coordinates (boxX, boxY)
 * and local cell relative coordinates (cellX, cellY) from 0..9.
 * Properly supports negative world coordinates.
 */
export function cellToBox(x: number, y: number): CellBoxPosition {
  const boxX = Math.floor(x / BOX_SIZE);
  const boxY = Math.floor(y / BOX_SIZE);
  const cellX = x - boxX * BOX_SIZE;
  const cellY = y - boxY * BOX_SIZE;

  return { boxX, boxY, cellX, cellY };
}

/**
 * Converts box coordinates and local cell relative coordinates (0..9) back to world (x, y).
 */
export function boxCellToWorld(
  boxX: number,
  boxY: number,
  cellX: number,
  cellY: number
): WorldCoord {
  return {
    x: boxX * BOX_SIZE + cellX,
    y: boxY * BOX_SIZE + cellY,
  };
}

/**
 * Formats box coordinate as a string key for maps/sets ("boxX,boxY").
 */
export function boxKey(boxX: number, boxY: number): string {
  return `${boxX},${boxY}`;
}

/**
 * Formats cell world coordinate as a string key ("x,y").
 */
export function cellKey(x: number, y: number): string {
  return `${x},${y}`;
}

/**
 * Parses box key string back into BoxCoord.
 */
export function parseBoxKey(key: string): BoxCoord {
  const [boxX, boxY] = key.split(',').map(Number);
  return { boxX, boxY };
}

/**
 * Parses cell key string back into WorldCoord.
 */
export function parseCellKey(key: string): WorldCoord {
  const [x, y] = key.split(',').map(Number);
  return { x, y };
}
